<script>
export default {
  props: {
    datasource: Object,
    callRefresh: {
      type: Boolean,
      default: true,
    },
    value: Array,
  },
  data() {
    return {
      localCallRefresh: this.callRefresh,
    }
  },
  methods: {
    changeCallRefreshValue(val) {
      this.localCallRefresh = val
    },
    renderSelectButton(h, item, icon) {
      return this.renderButton(h, item, 'item-selected', icon)
    },
    renderButton(h, item, event, icon) {
      const _vm = this
      return h(
        'v-btn',
        {
          attrs: {
            flat: true,
            icon: true,
            class: 'ma-0',
          },
          on: {
            click() {
              _vm.$emit(event, item)
            },
          },
        },
        [h('v-icon', {}, [icon])],
      )
    },
    refreshDatasourceIfNecessary() {
      if (this.localCallRefresh === true) {
        this.datasource.refresh()
      }
    },
    renderBoolean(h) {
      return h('v-icon')
    },
    renderSelectLink(h, item, components) {
      const _vm = this
      return h(
        'a',
        {
          on: {
            click() {
              _vm.$emit('item-selected', item)
            },
          },
        },
        components,
      )
    },
    renderLinkTo(h, item, components) {
      const to = this.datasource.linkTo(item)
      return h(
        'router-link',
        {
          props: {
            to,
          },
        },
        components,
      )
    },
    renderCell(h, item, field) {
      const customTdProps = {}
      const components = []
      if (field.value === '_select') {
        components.push(this.renderSelectButton(h, item, 'edit'))
      } else if (field.value === '_add') {
        components.push(this.renderSelectButton(h, item, 'add_circle_outline'))
      } else if (field.value === '_link') {
        components.push(this.renderLinkTo(h, item, [h('v-icon', {}, ['link'])]))
      } else if (field.value === '_alarms') {
        if (item[field.value]) {
          components.push(h('v-icon', {}, ['priority_high']))
        }
      } else if (field.value === '_delete') {
        components.push(this.renderButton(h, item, 'item-deleted', 'delete'))
      } else if (field.check) {
        components.push(
          h('input', {
            attrs: {
              type: 'checkbox',
              checked: item[field.value],
              disabled: true,
            },
          }),
        )
      } else {
        var text = null
        if (typeof field.formatter === 'function') {
          text = field.formatter(h, item, item[field.value])
        } else {
          text = this.getFieldValue(item, field.value)
          if (text && text.Label !== undefined) {
            // possibility to display a linkedObject
            text = item[field.value].Label
          }
        }

        if (field.props !== undefined) {
          Object.assign(customTdProps, field.props)
        }

        if (field.linkTo) {
          components.push(this.renderLinkTo(h, item, [text]))
        } else if (field.select) {
          components.push(this.renderSelectLink(h, item, [text]))
        } else {
          components.push(text)
        }
      }
      return h('td', customTdProps, components)
    },
    getFieldValue(item, path) {
      var index = path.indexOf('.')
      if (index === -1) {
        return item[path]
      } else {
        if (item[path.substring(0, index)]) {
          return this.getFieldValue(
            item[path.substring(0, index)],
            path.substring(index + 1),
          )
        } else {
          return null
        }
      }
    },
  },
  render(h) {
    const _vm = this
    const scopedSlots = {}
    Object.assign(scopedSlots, _vm.$scopedSlots)
    const datasource = _vm.datasource
    if (!scopedSlots.headerCell) {
      scopedSlots.headerCell = (props) => {
        if (props.header.icon) {
          return h('v-icon', {}, [props.header.icon])
        } else {
          return this.$t(props.header.text)
        }
      }
    }

    const progress = h(
      'v-progress-linear',
      {
        slot: 'progress',
        props: {
          indeterminate: true,
          color: 'accent',
        },
      },
      [],
    )
    // const footer = h('footer', { slot: 'footer',}, [_vm.$slots.footer]);

    return h(
      'v-data-table',
      {
        props: {
          'must-sort': true,
          headers: datasource.fields,
          items: datasource.items,
          page: datasource.pagination.page,
          itemsPerPage: datasource.pagination.rowsPerPage,
          sortBy: datasource.pagination.sortBy,
          sortDesc: datasource.pagination.descending,
          'server-items-length': datasource.totalRows,
          'show-select': datasource.showSelect,
          'show-expand': datasource.showExpand,
          loading: datasource.loading,
          'no-data-text': datasource.noDataText || this.$t('noDataText'),
          'no-results-text':
            datasource.noResultsText || this.$t('dataIterator.noResultsText'),
          dense: datasource.dense,
          value: _vm.value,
          footerProps: {
            itemsPerPageOptions: [10, 15, 20],
            'items-per-page-text': this.$t('dataTable.rowsPerPageText'),
            pagination: {
              page: datasource.pagination.page,
              itemsPerPage: datasource.pagination.rowsPerPage,
              itemsLength: datasource.totalRows,
              pageCount:
                datasource.totalRows / datasource.pagination.rowsPerPage,
              pageStart:
                (datasource.pagination.page - 1) *
                datasource.pagination.rowsPerPage,
              pageStop:
                datasource.pagination.page * datasource.pagination.rowsPerPage,
            },
          },
        },
        scopedSlots: scopedSlots,
        on: {
          'update:page': function (page) {
            datasource.pagination.page = page
            _vm.refreshDatasourceIfNecessary()
          },
          'update:items-per-page': function (itemsPerPage) {
            datasource.pagination.rowsPerPage = itemsPerPage
            _vm.refreshDatasourceIfNecessary()
          },
          'update:sort-by': function (sortBy) {
            datasource.pagination.sortBy = sortBy
            _vm.refreshDatasourceIfNecessary()
          },
          'update:sort-desc': function (sortDesc) {
            datasource.pagination.descending = sortDesc
            _vm.refreshDatasourceIfNecessary()
          },
          'click:row': function (item, row) {
            _vm.$emit('click:row', item, row)
          },
          'dblclick:row': function (item) {
            _vm.$emit('dblclick:row', item)
          },
          'toggle-select-all': function (item) {
            _vm.$emit('toggleSelect', item)
          },
          'item-selected': function (item) {
            _vm.$emit('itemSelected', item)
          },
          input: function (item) {
            _vm.$emit('input', item)
          },
        },
      },
      [progress],
    )
  },
}
</script>

<style scoped>
table.v-table thead tr {
  height: 40px;
}

a > .theme--light.v-icon {
  color: inherit;
}

table.v-table tbody td {
  height: 32px !important;
}

.dense table.v-table tbody td,
.dense table.v-table thead th.column {
  padding: 0 10px;
}
</style>
